import React, { Component } from 'react';
import { connect } from 'react-redux';

import { createCategoryList } from '../actions/CategoryListActions';

import { Pane, Heading, Button } from 'evergreen-ui';
import InfoBlock from '../../common/InfoBlock/InfoBlock';

import { Link } from 'react-router-dom';
import CategoryListForm from '../components/CategoryListForm';

import Configuration from '../Config';

const validation = Configuration.Validations.categoryList;
const defaultValues = Configuration.Defaults.createCategoryList;
const mapValidationErrors = Configuration.ErrorHandler.mapValidationErrors;

class CraeteCategoryList extends Component {
    componentDidMount() {
       
    }

    handleSave = (values) => {
        this.props.dispatch(createCategoryList(values));
    }

    render() {
        return (
            <Pane padding={16} paddingTop={0}>
                <Pane display="flex">
                    <Pane>
                        <Link to="/category-lists">
                            <Button iconBefore="arrow-left" intent="none">
                                Inapoi la liste categorii
                            </Button>
                        </Link>
                    </Pane>
                </Pane>

                <Pane flex={1} background="tint1" elevation={1} padding={16} marginTop={16}>
                    <Heading size={600}>
                        Lista categorii noua
                    </Heading>
                </Pane>
                
                <Pane display="flex" justifyContent="space-between" flex={1} marginTop={16}>
                    <InfoBlock flex="1">
                        <CategoryListForm 
                            isEdit={false}
                            initialValues={defaultValues}
                            validationSchema={validation}
                            onSave={this.handleSave}
                            errors={this.props.errors}/>
                    </InfoBlock>
                </Pane>

            </Pane>
        )
    }
}

function mapStateToProps(state) {
    return {
        errors: state.categoryLists.errors.type === 'validation' ? mapValidationErrors(state.categoryLists.errors.fields): [],
    }
}

export default connect(mapStateToProps)(CraeteCategoryList);